import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const declarationsCustomsContract = c.router({
  checkIntracomVat: {
    method: 'PATCH',
    path: '/declarations/:lrn/check-intracom-vat',
    pathParams: z.object({ lrn: z.string() }),
    body: z.object({ eori: z.string() }),
    responses: {
      200: z.object({ isValid: z.boolean() }),
    },
  },
  checkImporterEori: {
    method: 'PATCH',
    path: '/declarations/:lrn/check-importer-eori',
    pathParams: z.object({ lrn: z.string() }),
    body: z.object({ eori: z.string() }),
    responses: {
      200: z.object({ isValid: z.boolean() }),
    },
  },
  checkExporterEori: {
    method: 'PATCH',
    path: '/declarations/:lrn/check-exporter-eori',
    pathParams: z.object({ lrn: z.string() }),
    body: z.object({ eori: z.string() }),
    responses: {
      200: z.object({ isValid: z.boolean() }),
    },
  },
  markCustomsNotificationAsRead: {
    method: 'PATCH',
    path: '/declarations/:declarationId/customs-notifications/:notificationId/read',
    pathParams: z.object({ declarationId: z.string(), notificationId: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  resendDeclarationsWithSameLrn: {
    method: 'POST',
    path: '/declarations/:batchId/resend-declarations-with-same-lrn',
    pathParams: z.object({ batchId: z.string() }),
    body: z.object({ lrns: z.array(z.string()) }),
    responses: {
      200: z.object({}),
    },
  },
  invalidateOneReleasedToPlda: {
    method: 'POST',
    path: '/declarations/invalidate-one-released-to-plda',
    body: z.object({ LRN: z.string(), reason: z.string() }),
    responses: {
      200: z.object({}),
    },
  },
  invalidateReleasedToPlda: {
    method: 'POST',
    path: '/declarations/invalidate-released-to-plda',
    body: z.object({ batchId: z.string(), reason: z.string() }),
    responses: {
      200: z.object({}),
    },
  },
});
